module.exports = __webpack_public_path__ + "static/img/13.3f39e7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/13.png
// module id = elen
// module chunks = 0